import React from 'react';
import { DropdownTooltipText } from '@instinet-analytics/semantic-ui-components';
import chartPreview from 'widgets/signalTiles/pfeTile/components/description/pfeTilePreview.png';

export const pfeTileDescription: DropdownTooltipText = {
    body: (
        <>
            <div>
                The Polarized Fractal Efficiency (PFE) Capsule provides an
                indication of the strength of either a bullish or bearish trend.
            </div>
        </>
    ),
    minPreviewHeight: 180,
    previews: [
        {
            title: 'Chart',
            src: chartPreview,
            altText: 'pfe-capsule-chart-preview',
        },
    ],
};
